<template>
	<div>
		<div class="flex">
			<div class="flex-column" style="width: 30%;justify-content: space-between;">
				<div class="single-card mb20" style="height: 100px;" >
					<div>
						<div class="fs18" style="font-weight:bolder;">
							欢迎！{{ user.name }}
						</div>
					</div>
					<div class="flex mt10 items-center">
						<div v-if="user.start_time != null" class="ml10">
							今日上班打卡时间: {{start_time}}
						</div>
						<div v-else class="ml10">
							今日尚未打卡
						</div>
					</div>
				</div>
				<div>
					<div>
						<div class="single-card" style="position: relative;">
							<div>
								<div class="fs16" style="font-weight:bolder;">
									考勤管理
								</div>
							
							</div>

							<div class="flex mt20 items-center">
								<a-progress type="circle" :percent="parseInt(((attendanceStatistics.sign_total/attendanceStatistics.total)*100).toFixed(0))"  :width="60" />
								<div class="ml10">
									<div class="fs14" style="font-weight:bolder;">
										考勤统计
									</div>
									<div class="flex mt10">
										<div class="flex items-center mr10" style="width: 100px;">
											<a-icon class="mr2" type="right-circle" theme="filled" style="color:lightgray"/>
											<div class="fs12" style="color: grey;">
												{{ attendanceStatistics.total }}人 全部
											</div>
										</div>
										<div class="flex items-center ml20" >
											<a-icon class="mr2"  type="right-circle" theme="filled" style="color:lightgray"/>
											<div class="fs12" style="color: grey;">
												{{ attendanceStatistics.sign_total }}人 打卡
											</div>
										</div>
									</div>
									<div class="flex mt5">
										<div class="flex items-center mr10"  style="width: 100px;">
											<a-icon class="mr2" type="right-circle" theme="filled" style="color:lightgray"/>
											<div class="fs12" style="color: grey;">
												{{ attendanceStatistics.late_total }}人 迟到
											</div>
										</div>
										<div class="flex items-center ml20" >
											<a-icon class="mr2"  type="right-circle" theme="filled" style="color:lightgray"/>
											<div class="fs12" style="color: grey;">
												{{ attendanceStatistics.total - attendanceStatistics.sign_total }}人 旷工
											</div>
										</div>
									</div>
								
								</div>
							</div>
							<a-button @click="goAttendance" style="position: absolute;right: -5%;bottom: 0%;" size="small" type="link">
								详情<a-icon type="right" />
							</a-button>
					
						</div>
					</div>
					
					<div class="mt20" style="position: relative;">
						<div class="single-card">
							<div>
								<div class="fs16" style="font-weight:bolder;">
									合同管理
								</div>
							
							</div>
							<div class="flex mt20 items-center">
								<a-progress type="circle" :percent="contractApprove.rate"  :width="60" />
								<div class="ml10">
									<div class="fs14" style="font-weight:bolder;">
										合同审批进度
									</div>
									<div class="flex mt10">
										<div class="flex items-center mr10" style="width: 100px;">
											<a-icon class="mr2" type="right-circle" theme="filled" style="color:lightgray"/>
											<div class="fs12" style="color: grey;">
												{{contractApprove.total}}份 累计
											</div>
										</div>
										<div class="flex items-center ml20" >
											<a-icon class="mr2"  type="right-circle" theme="filled" style="color:lightgray"/>
											<div class="fs12" style="color: grey;">
												{{ contractApprove.total - contractApprove.pass_total }}份 审批中
											</div>
										</div>
									</div>

								</div>
							</div>
						</div>
						<a-button @click="goContract" style="position: absolute;right: -5%;bottom: 0%;" size="small" type="link">
							详情<a-icon type="right" />
						</a-button>
					</div>
				</div>
				

			</div>
			<div class=""  style="width: 70%;">
				<a-card :bordered="false" class="ml20 header-solid" :bodyStyle="{padding: 0,}" >
					<template #title>
						<a-row type="flex" align="middle">
							<a-col :span="24" :md="12">
								<h5>项目进度</h5>			
								<p>当前正在进行{{projectSchedule.build}}个项目，当前已完工<span class="text-primary">{{ projectSchedule.total-projectSchedule.build }}</span>个项目</p>
							</a-col>
						</a-row>
					</template>
				
					<a-table :columns="columns" :data-source="data" :pagination="false">

						<template slot="company" slot-scope="company">
							<h6 class="m-0">
								<img :src="company.logo" width="25" style="margin-right: 10px;">
								{{ company.name }}
							</h6>
						</template>
						<template slot="completion" slot-scope="completion">
							<div class="progress-right">
								<div class="text-right text-sm font-semibold text-muted pr-15">{{ completion.value || completion.value == 0 ? completion.value : completion }}%</div>
								<a-progress class="m-0" :percent="completion.value || completion.value == 0 ? completion.value : completion" :show-info="false" size="small" :status="completion.status ? completion.status : 'normal'" />
							</div>
						</template>
					</a-table>
				</a-card>
			</div>
			
		</div>


		
		<!-- <div class="flex mt20 pb10">
			<div style="width: 30%;">
				<a-card :bordered="false" class="ml20 header-solid" :bodyStyle="{paddingTop: '12px'}">
					<template #title>
						<h6>今日入库记录</h6>			
						<p>共计 <span class="text-success">{{storageRecord.total}}</span>条</p>	
					</template>
					<a-timeline pending="查看更多..." :reverse="timelineReverse" @click="">
						<a-timeline-item color="green" v-for="item in storageRecord.data" :key="item.key">
							{{item.material_name}} - {{item.project_name}} - {{item.count}}{{ item.unit }}
							<p>{{item.create_time}}</p>
						</a-timeline-item>
						<template #pendingDot> </template>
					</a-timeline>
				
				</a-card>
			</div>
			<div class="ml20" style="width: 70%;" >
				<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
					<template #title>
						<a-row type="flex" align="middle">
							<a-col :span="24" :md="12">
								<h5 class="font-semibold m-0">物资库存预警</h5>
							</a-col>
						</a-row>
					</template>
					<a-table :columns="table2Columns" :data-source="table2Data" :pagination="false">

						<template slot="name" slot-scope="text">
							<a>{{ text }}</a>
						</template>
						<template slot="company" slot-scope="company">
							<h6 class="m-0">
								<img :src="company.logo" width="25" style="margin-right: 10px;">
								{{ company.name }}
							</h6>
						</template>

						<template slot="completion" slot-scope="completion">
							<span class="font-bold text-muted text-sm">{{ completion.label ? completion.label : completion }}</span>
							<a-progress :percent="completion.value ? completion.value : completion" :show-info="false" size="small" :status="completion.status ? completion.status : 'normal'" />
						</template>
					</a-table>
				</a-card>
			</div>			
		</div> -->
		<div class="mt20 pb10 ">
			<a-card :bordered="false" class="header-solid" :bodyStyle="{padding: 0,}" >
				<template #title>
					<div class="flex items-center" style="justify-content: space-between;">
						<div>
							<h5>合同统计</h5>
							<p>今日已提交{{contractToday.total}}份合同，已审批<span class="text-primary">{{ contractToday.pass_total }}</span>份</p>

						</div>
						<a-range-picker class="mr10" :placeholder="['开始日期', '结束日期']"  @change="onChange"/>
					</div>
				
				</template>
			
				<a-table :columns="contractColumns" :data-source="contractData" :pagination="false">
					<template slot="new" slot-scope="text,record">
						<div class="progress-right">
							{{ text }}份
						</div>
					</template>
					<template slot="waiting" slot-scope="text,record">
						<div class="progress-right">
							{{ text }}份
						</div>
					</template>
					<template slot="completion" slot-scope="completion">
						<div class="progress-right">
							<div class="text-right text-sm font-semibold text-muted pr-15">{{ completion.value || completion.value == 0 ? completion.value : completion }}%</div>
							<a-progress class="m-0" :percent="completion.value || completion.value == 0 ? completion.value : completion" :show-info="false" size="small" :status="completion.status ? completion.status : 'normal'" />
						</div>
					</template>
				</a-table>
			</a-card>
		</div>
		

		
	</div>
  </template>
  
  <script>

  export default {
	components: {

	},
	data () {
	  	return {
			columns:[
				{
					title: '项目名称',
					dataIndex: 'company',
					scopedSlots: { customRender: 'company' },
					width: '40%',
				},
				{
					title: '项目经理',
					dataIndex: 'member',
					width: '20%',
					scopedSlots: { customRender: 'member' },
				},
				{
					title: '开始日期',
					dataIndex: 'begin',
					width: '20%',
					class: 'font-bold text-muted text-sm',
				},
				{
					title: '进度',
					scopedSlots: { customRender: 'completion' },
					dataIndex: 'completion',
				},
			],
			data:[
				
			],
			table2Columns:[
				{
					title: '名称',
					dataIndex: 'company',
					scopedSlots: { customRender: 'company' },
					width: 300,
				},
				{
					title: '所属项目',
					dataIndex: 'project',
					class: 'font-semibold text-muted',
				},
				{
					title: '项目经理',
					dataIndex: 'manager',
					class: 'font-semibold text-muted text-sm',
				},
				{
					title: '库存',
					scopedSlots: { customRender: 'completion' },
					dataIndex: 'completion',
				},
			],
			table2Data:[
			],
			contractColumns:[
				{
					title: '日期',
					dataIndex: 'date',
					scopedSlots: { customRender: 'date' },
				},
				{
					title: '新增合同',
					dataIndex: 'new',
					scopedSlots: { customRender: 'new' },

				},
				{
					title: '待审批',
					dataIndex: 'waiting',
					class: 'font-bold text-muted text-sm',
					scopedSlots: { customRender: 'waiting' },
				},
				{
					title: '进度',
					scopedSlots: { customRender: 'completion' },
					dataIndex: 'completion',
				},
			],
			contractData:[{key:0, date:"", new:0, waiting:0, completion:{status: null,value: 0},}],
			logo_list:['images/logos/logo-spotify.svg', 'images/logos/logo-atlassian.svg', 'images/logos/logo-slack.svg', 'images/logos/logo-spotify.svg', 'images/logos/logo-webdev.svg'],
			projectHeaderBtns: 'all',
			timelineReverse: false,
			attendanceStatistics:{total:0, sign_total:0, late_total:0},
			contractApprove:{},
			contractToday:{},
			projectSchedule:{total:0, build:0},
			storageRecord:{total:0, data:[]},
			materialInventory:[],
			user:{},
			value:[],
	  	}
	},
	computed: {
       
	},
	created () {
		this.getDailyAttendanceStatistics()
		this.getDailyContractApprove()
		this.getDailyProjectSchedule()
		this.getLoginUserDetail()
		// this.getDailyStorageRecord()
		// this.getDailyMiniMaterialInventory()

	},
	mounted () {
	 
	},
	methods: {
		async getDailyAttendanceStatistics(){
			let rs = await this.$api.getDailyAttendanceStatistics()
			console.log(rs.data)
			if(rs.err == 0){
				this.attendanceStatistics = rs.data
			}
		},
		async getDailyContractApprove(){
			let rs = await this.$api.getDailyContractApprove()
			console.log(rs)
			if(rs.err == 0){
				this.contractApprove = rs.total
				this.contractApprove.rate = parseInt((this.contractApprove.total != 0)?((this.contractApprove.pass_total/this.contractApprove.total)*100).toFixed(0):0)
				this.contractToday = rs.today
				let ca = 1
				for(let item of rs.data){
					item.key = ca
					item.waiting = item.new - item.finish
					item.completion = {status:null, value:0}
					item.completion.value = parseInt((item.new!=0)?((item.finish/item.new)*100).toFixed(0):0)
					item.completion.status = (item.completion.value == 100)?'success':(item.completion.value>50?'normal':'exception')
					ca++
				}
				
				this.contractData = rs.data

			}
		},
		async getDailyProjectSchedule(){
			let rs = await this.$api.getDailyProjectSchedule()
			console.log(rs)
			if(rs.err == 0){
				let ca = 0
				this.data = []
				for(let item of rs.data){
					let as = {key:0, company:{name:"", logo:""}, member:"", begin:"", completion:{status: null,value: 0},}
					as.key = ca + 1
					as.company.name = item.name
					as.company.logo = this.logo_list[ca]
					as.member = item.manager
					as.begin = item.begin
					as.completion.value = parseInt((item.total_amount!=0)?((item.done_amount/item.total_amount)*100).toFixed(2):0)
					as.completion.status = (as.completion.value == 100)?'success':(as.completion.value>50?'normal':'exception')
					ca ++
					this.data.push(as)
				}
				this.projectSchedule.total = rs.total
				this.projectSchedule.build = rs.build
			}
		},
		async getDailyStorageRecord(){
			let rs = await this.$api.getDailyStorageRecord()
			console.log(rs.data)
			if(rs.err == 0){
				this.storageRecord.data = rs.data
				this.storageRecord.total = rs.total
			}
		},
		async getDailyMiniMaterialInventory(){
			let rs = await this.$api.getDailyMiniMaterialInventory()
			if(rs.err == 0){
				let ca = 0
				this.table2Data = []
				for(let item of rs.data){
					let as = {key:0, company:{name:"", logo:""}, manager:"", project:"", completion:{status: null,value: 0}}
					as.key = ca + 1
					as.company.name = item.name
					as.company.logo = this.logo_list[ca]
					as.manager = item.manager
					as.project = item.project_name
					as.completion.value = item.count
					as.completion.status = (as.completion.value == 100)?'success':(as.completion.value>50?'normal':'exception')
					ca ++
					this.table2Data.push(as)
				}

				this.materialInventory = rs.data
			}
		},
		async getLoginUserDetail(){
			let rs = await this.$api.getLoginUserDetail()
			console.log(rs.data)
			if(rs.err == 0){
				this.user = rs.data
			}
		},
		onChange(date, dateString) {
			this.start_date = dateString[0]
			this.end_date = dateString[1]
			console.log(dateString)
			this.getDailyContractData(this.start_date, this.end_date)
			
		},
		async getDailyContractData(t1, t2){
			let rs = await this.$api.getDailyContractData(t1, t2)
			if(rs.err == 0){
				this.contractData = rs.data
			}
		},
		async goAttendance(){
			this.$router.push(`/personnel/attendance/form`)
		},
		goContract(){
			this.$router.push(`/contract/contract`)
		}

	}
  }
  </script>
  
  <style scoped>
	.single-card {
		border-radius: 0.625rem;
		box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
		background-color: white;
		padding: 20px;
	}
	.ant-carousel >>> .slick-slide {
		text-align: center;
		height: 160px;
		line-height: 160px;
		background: #bdbdbd;
		overflow: hidden;
	}

	.ant-carousel >>> .custom-slick-arrow {
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #fff;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.3;
	}
	.ant-carousel >>> .custom-slick-arrow:before {
		display: none;
	}
	.ant-carousel >>> .custom-slick-arrow:hover {
		opacity: 0.5;
	}

	.ant-carousel >>> .slick-slide h3 {
		color: #fff;
	}
  </style>
  